import { Component, computed, signal } from '@angular/core';
import { Dropdown, DropdownOption } from '@ntv360/component-pantry';
import {
    StatsCardComponent,
    TableComponent,
    TableToolbarButton,
    TableToolbarComponent,
} from '@shared';
import { getStandardToolbarButtons } from '@shared/utils';
import {
    INSTALLATIONS_COLUMNS,
    INSTALLATIONS_DUMMY_DATA,
    INSTALLATIONS_STATS,
} from './constants/dummyData.constants';

const SORT_OPTIONS: DropdownOption[] = [
    { label: 'Default', value: 'default' },
    { label: 'Upcoming', value: 'upcoming' },
    { label: 'Recent', value: 'recent' },
    { label: 'Next Week', value: 'next-week' },
    { label: 'Next Month', value: 'next-month' },
];

@Component({
    selector: 'app-installations',
    imports: [StatsCardComponent, TableToolbarComponent, TableComponent, Dropdown],
    templateUrl: './installations.component.html',
    styleUrl: './installations.component.scss',
})
export class InstallationsComponent {
    public statsData = INSTALLATIONS_STATS;
    public licenseColumns = INSTALLATIONS_COLUMNS;

    public tableData = signal<any[]>(INSTALLATIONS_DUMMY_DATA);
    public isLoading = signal<boolean>(false);
    public selectedRows = signal<any[]>([]);
    public searchTerm = signal<string>('');
    public selectedSort = signal<DropdownOption | null>(null);

    public sortConfig = computed(() => ({
        options: SORT_OPTIONS,
        placeholder: 'Default',
        fullWidth: false,
        value: this.selectedSort()?.value ?? null,
    }));

    public toolbarButtons = computed<TableToolbarButton[]>(() =>
        getStandardToolbarButtons(this.selectedRows().length),
    );

    public onSortChange(option: DropdownOption | null): void {
        this.selectedSort.set(option);
    }

    public onSearch(term: string): void {
        this.searchTerm.set(term);
    }

    public onToolbarAction(_action: string): void {}

    public onActionClick(_event: { action: string; row: any }): void {}

    public onSelectionChange(rows: any[]): void {
        this.selectedRows.set(rows);
    }
}
